import { prettyMilliseconds } from "@-/com.npmjs.pretty-ms";

/**
 * Formats an FSRS `due` timestamp into a compact label for a card tile's
 * bottom-right corner. The slot is tiny, so labels stay short: `5d` / `3h` /
 * `5m`, `Due` once the card is due (past or now), `Tomorrow` when the due time
 * falls in the next calendar day (so it never reads `23h` while sitting under
 * "Due Later"), and `undefined` when the card has no schedule yet (so the
 * caller renders no label).
 */
export function formatCardDueLabel(due: string | null, now: Date = new Date()): string | undefined {
  if (due === null) {
    return undefined;
  }

  const dueDate = new Date(due);
  const dueTime = dueDate.getTime();
  if (Number.isNaN(dueTime)) {
    return undefined;
  }

  const remainingMs = dueTime - now.getTime();
  if (remainingMs <= 0) {
    return "Due";
  }

  const endOfToday = new Date(now);
  endOfToday.setHours(23, 59, 59, 999);
  const endOfTomorrow = new Date(endOfToday);
  endOfTomorrow.setDate(endOfTomorrow.getDate() + 1);
  if (dueTime > endOfToday.getTime() && dueTime <= endOfTomorrow.getTime()) {
    return "Tomorrow";
  }

  return prettyMilliseconds(Math.max(60_000, remainingMs), { compact: true });
}
